export default "__VITE_ASSET__Cks5Okae__"